/* eslint-disable import/no-deprecated */
import { beginningOfMonth, cloneDate, numWeeksInMonth } from '@fullstory/util/date';
import React from 'react';
import { DayView } from './DayView';
import { WeekView } from './WeekView';

/**
 * @deprecated
 * `MonthView` renders a list of weeks.
 */
export const MonthView: React.FC<React.ComponentProps<typeof DayView>> = ({ date, ...rest }) => {
  const weeks = [];
  const tempDate = beginningOfMonth(date);
  const numWeeks = numWeeksInMonth(cloneDate(tempDate));
  for (let i = 0; i < numWeeks; i++) {
    weeks.push(<WeekView key={i} date={cloneDate(tempDate)} {...rest} />);
    const lastDayDate = cloneDate(tempDate);
    lastDayDate.setDate(lastDayDate.getDate() + 6);
    tempDate.setDate(tempDate.getDate() + 7);
  }
  return <>{weeks}</>;
};
